import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function BatterySaverIcon(props: IconProps) {
    return <Icon {...props} iconKey={"battery_saver"}/>
}
